import { FC, memo, useState } from 'react'

import { useNavigate } from '@tanstack/react-router'
import { ButtonGroup } from 'ui/components'
import { Button } from 'ui/components/Buttons'
import { useConfirmation } from 'ui/hooks'

import { patchApplicationAcknowledgeWarnings } from '../services'
import { FooterProps } from './FooterProps'

import * as SC from './styles'

export const Footer: FC<FooterProps> = memo((props) => {
  const { applicationId, data } = props
  const navigate = useNavigate()
  const [isSubmitting, setIsSubmitting] = useState(false)

  const moveToApplication = () => {
    navigate({ to: '/onboarding/applications/$applicationId', params: { applicationId: applicationId.toString() } })
  }

  const submit = () => {
    setIsSubmitting(true)
    patchApplicationAcknowledgeWarnings(applicationId)
      .then(() => {
        moveToApplication()
      })
      .finally(() => {
        setIsSubmitting(false)
      })
  }

  const { open: openConfirmation, Confirmation } = useConfirmation({
    message: (
      <span>Are you sure you want to&nbsp;acknowledge these changes? This action cannot&nbsp;be&nbsp;undone</span>
    ),
    onConfirm: () => submit(),
    confirmationButtonText: 'Submit'
  })

  return (
    <SC.Wrapper>
      <Confirmation />
      <SC.FooterMessage>{data.footerMessage}</SC.FooterMessage>
      <ButtonGroup margin="small">
        {!data.showAcknowledgeButton && (
          <Button face="secondary" onClick={moveToApplication}>
            Back
          </Button>
        )}
        {data.showAcknowledgeButton && (
          <>
            <Button face="secondary" onClick={moveToApplication}>
              Skip For Now
            </Button>
            <Button loading={isSubmitting} face="primary" onClick={() => openConfirmation()}>
              Acknowledge
            </Button>
          </>
        )}
      </ButtonGroup>
    </SC.Wrapper>
  )
})
